module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "peu-poi-active.625eacf8.svg";